// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3uJ5V","errors":"Errors_errors__3dAxZ"};